package fr.frux.shared.di

import dev.zacsweers.metro.createGraph

/**
 * Factory function to create AppComponent for Web (js).
 * Mirrors createAndroidAppComponent().
 */
fun createWebAppComponent(): AppComponent {
    return createGraph<AppComponent>()
}
